import { useEffect, useState } from 'react';
import { NewsletterModal } from './NewsletterModal';

type PassThroughProps = {
   storeCode: string;
   privacyPolicyUrl: string;
};

export function TimeDelayNewsletterModal({
   timeInMs,
   storeCode,
   privacyPolicyUrl,
}: PassThroughProps & { timeInMs: number }) {
   const [isOpen, setIsOpen] = useState(false);

   useEffect(() => {
      const timer = setTimeout(() => {
         setIsOpen(true);
      }, timeInMs);

      return () => clearTimeout(timer);
   }, [timeInMs]);

   return (
      <NewsletterModal
         open={isOpen}
         onClose={() => setIsOpen(false)}
         storeCode={storeCode}
         privacyPolicyUrl={privacyPolicyUrl}
      />
   );
}

export function ScrollPercentageNewsletterModal({
   percentage,
   storeCode,
   privacyPolicyUrl,
}: PassThroughProps & { percentage: number }) {
   const [isOpen, setIsOpen] = useState(false);

   useEffect(() => {
      function handleScroll() {
         const scrollTop = window.scrollY;
         const docHeight = document.documentElement.scrollHeight - window.innerHeight;
         if (docHeight <= 0) return;
         const scrolledPercentage = (scrollTop / docHeight) * 100;

         if (scrolledPercentage >= percentage) {
            setIsOpen(true);
            window.removeEventListener('scroll', handleScroll);
         }
      }

      handleScroll(); // Check on mount in case user has already scrolled

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
   }, [percentage]);

   return (
      <NewsletterModal
         open={isOpen}
         onClose={() => setIsOpen(false)}
         storeCode={storeCode}
         privacyPolicyUrl={privacyPolicyUrl}
      />
   );
}
